export const NAV_LINKS = [
  { label: "About",              id: "about" },
  { label: "Services",           id: "services" },
  { label: "Job Opportunities",  id: "careers-abroad" },
  { label: "Contact",            id: "contact" },
];

export const SERVICES = [
  {
    icon: "✈",
    title: "Air Ticketing",
    desc: "International & domestic flight bookings tailored to your schedule and budget.",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80",
  },
  {
    icon: "🏨",
    title: "Hotels & Accommodation",
    desc: "Curated hotel reservations and accommodation booking worldwide.",
    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80",
  },
  {
    icon: "🌍",
    title: "Tour Packages",
    desc: "Bespoke holiday packages and group travel experiences across the globe.",
    image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80",
  },
  {
    icon: "📋",
    title: "Visa Assistance",
    desc: "Professional visa application support and travel documentation guidance.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
  },
  {
    icon: "🛡",
    title: "Travel Insurance",
    desc: "Comprehensive insurance arrangements for complete peace of mind abroad.",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
  },
  {
    icon: "🚗",
    title: "Airport Transfers",
    desc: "Seamless ground transportation and airport transfer services.",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&q=80",
  },
  {
    icon: "💼",
    title: "Corporate Travel",
    desc: "End-to-end corporate and group travel management solutions.",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&q=80",
  },
  {
    icon: "💍",
    title: "Honeymoon Packages",
    desc: "Romantic, customized honeymoon experiences crafted for every couple.",
    image: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80",
  },
];

export const VALUES = [
  { title: "Integrity",   desc: "Honesty and ethical conduct in every engagement." },
  { title: "Excellence",  desc: "High standards of service delivery." },
  { title: "Reliability", desc: "Consistent and trustworthy solutions." },
  { title: "Innovation",  desc: "Embracing modern industry practices." },
];

export const STATS = [
  { n: "500", s: "+", label: "Clients Served" },
  { n: "50",  s: "+", label: "Destinations" },
  { n: "10",  s: "+", label: "Global Partners" },
  { n: "100", s: "%", label: "Ethical Practice" },
];

export const CAREERS_LIST = [
  "Overseas job search support and opportunity identification",
  "Candidate profiling and career guidance",
  "CV review and interview preparation",
  "Coordination with licensed recruitment agencies",
  "Employment travel planning and documentation guidance",
  "Visa-related advisory for employment travel",
  "Pre-departure orientation and relocation assistance",
];

export const TARGET_APPLICANTS = [
  { title: "Skilled Professionals", desc: "Experienced workers seeking international roles in their field." },
  { title: "Semi-Skilled Workers",  desc: "Capable candidates ready for overseas opportunities." },
  { title: "Graduates & Trainees",  desc: "Fresh graduates pursuing global exposure and growth." },
  { title: "Career Advancers",      desc: "Individuals leveraging global mobility for career growth." },
];

export const CONTACT_ITEMS = [
  { icon: "📍", heading: "Our Office",  detail: "Nanak House, Kimathi Street\n4th Floor, Room 407\nNairobi, Kenya" },
  { icon: "✉",  heading: "Email Us",    detail: "info@royalhorizonmobility.com" },
  { icon: "📞", heading: "Call Us",     detail: "+254 769 340 434" },
];

export const GALLERY_IMAGES = [
  "https://images.unsplash.com/photo-1500835556837-99ac94a94552?w=400&q=70",
  "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&q=70",
  "https://images.unsplash.com/photo-1530521954074-e64f6810b32d?w=400&q=70",
  "https://images.unsplash.com/photo-1488085061387-422e29b40080?w=400&q=70",
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=70",
  "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=400&q=70",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=400&q=70",
  "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&q=70",
];
